import { render } from "./VideoPlayerOverlay.vue?vue&type=template&id=705ffda2&ts=true"
import script from "./VideoPlayerOverlay.vue?vue&type=script&lang=ts"
export * from "./VideoPlayerOverlay.vue?vue&type=script&lang=ts"

import "./VideoPlayerOverlay.vue?vue&type=style&index=0&id=705ffda2&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__